import { render, staticRenderFns } from "./offershelp.vue?vue&type=template&id=2f5cdfcc&"
import script from "./offershelp.vue?vue&type=script&lang=js&"
export * from "./offershelp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../var/task/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/task/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('2f5cdfcc')) {
      api.createRecord('2f5cdfcc', component.options)
    } else {
      api.reload('2f5cdfcc', component.options)
    }
    module.hot.accept("./offershelp.vue?vue&type=template&id=2f5cdfcc&", function () {
      api.rerender('2f5cdfcc', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "tmp/tmp-28qZvRlhJ7vuJ/JS/offershelp.vue"
export default component.exports